import { ROUTES } from '@/shared/config/routes';

/**
 * Primary navigation, shared by the desktop bar and the mobile menu.
 *
 * Declared once as data so the two renderings can never drift apart — they did
 * in the generated code, where the same four links were typed out twice.
 */
export const NAV_LINKS = [
  { to: ROUTES.explore, labelKey: 'nav.findMaster', emphasis: true },
  { to: ROUTES.features, labelKey: 'nav.howItWorks', emphasis: false },
  { to: ROUTES.pricing, labelKey: 'nav.pricing', emphasis: false },
  { to: ROUTES.clientLogin, labelKey: 'nav.clientLogin', emphasis: false },
] as const;
